import React from "react";
import i18n from "i18next";

import store from "../../redux/store";
import { TooltipIcons } from "./Icons";

export const TooltipSeatChannel = (target: any, handleSelectObject: any, handleClose?: any) => {
    const {
        properties: { selectedChannel },
    } = store.getState();
    const isTouch = !!handleSelectObject;

    const getInfoSpan = () => {
        if (selectedChannel.key == '') {
            return <div className="box_btns_modal">
                <p>{i18n.t("tooltipSeat.first-select-channel")}</p>
                {isTouch && handleClose && (
                    <button className="btn_neutro for_close w-100" onClick={handleClose}>
                        Cerrar
                    </button>
                )}
            </div>
        }

        if (target.isSelected) {
            if (handleSelectObject)
                return (
                    <div className="box_btns_modal">
                        <button className="btn_neutro" onClick={handleSelectObject}>
                            <span className="icon-close"></span>{" "}
                            {i18n.t("tooltipSeat.deselect")}
                        </button>
                        {isTouch && handleClose && (
                            <button className="btn_neutro for_close" onClick={handleClose}>
                                Cerrar
                            </button>
                        )}
                    </div>
                );
            return (
                <div className="box_btns_modal">
                    <div className="box_channel_selected" style={{ width: '100%', marginBottom: '10px' }}>
                        <p>Seleccionado</p>
                    </div>
                    {isTouch && handleClose && (
                        <button className="btn_neutro for_close w-100" onClick={handleClose}>
                            Cerrar
                        </button>
                    )}
                </div>
            );
        } else {

            if (handleSelectObject)
                return (
                    <div className="box_btns_modal">
                        <button className="btn_neutro for_select" onClick={handleSelectObject}>
                            <span className="icon-checkmark"></span>{" "}
                            {i18n.t("tooltipSeat.select")}
                        </button>
                        {isTouch && handleClose && (
                            <button className="btn_neutro for_close" onClick={handleClose}>
                                Cerrar
                            </button>
                        )}
                    </div>
                );
            return (
                <div className="box_btns_modal">
                    {isTouch && handleClose && (
                        <button className="btn_neutro for_close w-100" onClick={handleClose}>
                            Cerrar
                        </button>
                    )}
                </div>
            );
        }
    };

    return (
        <div
            className={`wrapper_in_tooltip_seats ${isTouch ? 'is_mobile_modal' : ''}`}
            style={{ borderLeft: `4px solid ${target.channel.color}` }}
        >
            <div
                className="box_name_channel"
                style={{ backgroundColor: target.channel.color, color: 'white' }}
            >
                <p>{target.channel.name}</p>
            </div>

            {target.category && (
                <div
                    className="box_name_category"
                    style={{ color: target.category.color }}
                >
                    <p> {target.category.name}</p>
                </div>
            )}

            <TooltipIcons target={target} />

            <div className="box_details_seats">
                <p>
                    <span>
                        {i18n.t("tooltipSeat.section")}:{" "}
                        <strong>{target.sectionLabel || "?"}</strong>{" "}
                    </span>
                    &nbsp;
                </p>
                <p>
                    <span>
                        {i18n.t("tooltipSeat.row")}: <strong>{target.rowLabel || "?"}</strong>
                    </span>
                    &nbsp; &nbsp;
                    <span>
                        {i18n.t("tooltipSeat.seat")}:{" "}
                        <strong>{target.label || "?"}</strong>
                    </span>
                </p>
            </div>

            <div className="box_name_status">
                <p> {target.status}</p>
            </div>

            <div className="box_handle_mnsj">{getInfoSpan()}</div>
        </div>
    );
};